<template>
  <div class="flex items-center justify-between bg-white">
    <div class="flex items-center gap-4">
      <!-- Icon -->
      <component
        :is="icon"
        class="w-12 h-12 bg-slate-100 dark:bg-slate-700 rounded-xl p-1.5"
      />

      <!-- Title + Total Power -->
      <div :class="phases ? 'w-32' : ''">
        <p class="text-sm font-medium text-slate-500 dark:text-slate-400">
          {{ title }}
        </p>
        <p class="text-xl font-semibold text-slate-800 dark:text-white">
          <span v-if="txt==''">
          {{ $t('seteasybalance.powerkw', {
            Energy: $n(power, 'decimal', {
              minimumFractionDigits: 1,
              maximumFractionDigits: 2
            })
          }) }}
          </span>
          <span v-else>
              {{ txt }}
          </span>
        </p>

      </div>

      <!-- Phases -->
      <div v-if="phases" class="flex items-center gap-6">
        <div>
          <p class="text-xs font-medium text-slate-500">L1:</p>
          <p class="text-lg font-semibold text-slate-500">
            {{ $t('seteasybalance.powerkw', {
              Energy: $n(phase1, 'decimal', { minimumFractionDigits: 1, maximumFractionDigits: 2 })
            }) }}
          </p>
        </div>
        <div>
          <p class="text-xs font-medium text-slate-500">L2:</p>
          <p class="text-lg font-semibold text-slate-500">
            {{ $t('seteasybalance.powerkw', {
              Energy: $n(phase2, 'decimal', { minimumFractionDigits: 1, maximumFractionDigits: 2 })
            }) }}
          </p>
        </div>
        <div>
          <p class="text-xs font-medium text-slate-500">L3:</p>
          <p class="text-lg font-semibold text-slate-500">
            {{ $t('seteasybalance.powerkw', {
              Energy: $n(phase3, 'decimal', { minimumFractionDigits: 1, maximumFractionDigits: 2 })
            }) }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconSmartmeter from '../icons/IconSmartmeter.vue'
import IconPowerGrid from '../icons/IconPowerGrid.vue'
import IconFactory from '../icons/IconFactory.vue'
import IconCars from '../icons/IconCars.vue'
import IconPc from '../icons/IconPc.vue'

export default {
  name: 'PowerCard',
  components: { IconSmartmeter, IconPowerGrid, IconFactory, IconCars, IconPc },

  props: {
    /** Name of a registered component, e.g. "IconSmartmeter" */
    icon: { type: String, required: true },

    /** Label under the icon */
    title: { type: String, required: true },

    txt: { type: String, default: '' },    
    /** Total power (in W by default) */
    power: { type: Number, default: 0 },

    /** Show phase values (L1/L2/L3) */
    phases: { type: Boolean, default: false },

    /** Phase powers (in W by default) */
    phase1: { type: Number, default: 0 },
    phase2: { type: Number, default: 0 },
    phase3: { type: Number, default: 0 },
  },
}
</script>
